import React, { lazy } from "react";

const MasterLayout = lazy(() => import("../layouts/admin/MasterLayout.js"));
const Dashboard = lazy(() => import("../components/admin/Dashboard"));
const Profile = lazy(() => import("../components/admin/Profile.js"));
const CRMI = lazy(() => import("../components/admin/CrmInstance"));
const Orders = lazy(() => import("../components/admin/Orders.js"));
const AddProds = lazy(() => import("../components/admin/AddProds"));
const ListProducts = lazy(() => import("../components/admin/Viewprods"));
const Adduser = lazy(() => import("../components/admin/Adduser"));
const Listusers = lazy(() => import("../components/admin/Listusers"));
const Category = lazy(() => import("../components/admin/Category"));
const Brand = lazy(() => import("../components/admin/Brand"));
const ProductReview = lazy(() => import("../components/admin/ProductReview"));
const AddCheckoutFunnel = lazy(() =>
  import("../components/admin/AddCheckoutFunnel")
);
const CheckoutFunnelList = lazy(() =>
  import("../components/admin/CheckoutFunnelList")
);
const EditCheckoutFunnel = lazy(() =>
  import("../components/admin/EditCheckoutFunnel")
);
const AutoProductMap = lazy(() =>
  import("../components/admin/AutoProductMap")
);
const AssignementTemplate = lazy(() =>
  import("../components/admin/AssignementTemplate")
);
const AssignmentLander = lazy(() =>
  import("../components/admin/AssignmentLander")
);
const AssignmentUpsell = lazy(() =>
  import("../components/admin/AssignmentUpsell")
);
const Confirmation = lazy(() => import("../components/admin/Confirmation"));
const Funnelflow = lazy(() => import("../components/admin/FunnelFlow"));
const FunnelFlowList = lazy(() =>
  import("../components/admin/FunnelFlowList")
);
const FunnelFlowEdit = lazy(() => import("../components/admin/FunnelFlowEdit"));
const Bonus = lazy(() => import("../components/admin/Bonus"));
const BonusCategory = lazy(() =>
  import("../components/admin/BonusCategory")
);
const SapphireAddOn = lazy(() => import("../components/admin/SapphireAddOn"));
const DomainLogs = lazy(() => import("../components/admin/DomainLogs"));
const UserComments = lazy(() => import("../components/admin/UserComments"));
const FaqCategory = lazy(() => import("../components/admin/FaqCategory.js"));
const FaqSubCategory = lazy(() =>
  import("../components/admin/FaqSubCategory.js")
);
const FaqQueries = lazy(() => import("../components/admin/FaqQueries.js"));
const Survey = lazy(() => import("../components/admin/Survey.js"));
const SurveyFeedback = lazy(() =>
  import("../components/admin/SurveyFeedback.js")
);
const SupportLogs = lazy(() => import("../components/admin/SupportLogs.js"));
const ProspectReport = lazy(() =>
  import("../components/admin/ProspectReport.js")
);
const ProspectReportDetails = lazy(() =>
  import("../components/admin/ProspectReportDetails.js")
);
const ReportByProduct = lazy(() =>
  import("../components/admin/ReportByProduct.js")
);

export const AdminLayout = MasterLayout;

export const adminRoutes = [
  { path: "/admin/dashboard", element: <Dashboard /> },
  { path: "/admin/profile", element: <Profile /> },
  { path: "/admin/crminstance", element: <CRMI /> },
  { path: "/admin/orders", element: <Orders /> },
  { path: "/admin/addprods", element: <AddProds /> },
  { path: "/admin/viewprods", element: <ListProducts /> },
  { path: "/admin/productmapping", element: <AutoProductMap /> },
  { path: "/admin/users", element: <Adduser /> },
  { path: "/admin/listusers", element: <Listusers /> },
  { path: "/admin/category", element: <Category /> },
  { path: "/admin/brand", element: <Brand /> },
  { path: "/admin/product_review", element: <ProductReview /> },
  { path: "/admin/checkoutfunnels", element: <AddCheckoutFunnel /> },
  {
    path: "/admin/checkoutfunnelslist",
    element: <CheckoutFunnelList />,
  },
  {
    path: "/admin/checkoutfunnelsedit",
    element: <EditCheckoutFunnel />,
  },
  { path: "/admin/template", element: <AssignementTemplate /> },
  { path: "/admin/lander", element: <AssignmentLander /> },
  { path: "/admin/upsell", element: <AssignmentUpsell /> },
  { path: "/admin/confirmation", element: <Confirmation /> },
  { path: "/admin/funnelflow", element: <Funnelflow /> },
  { path: "/admin/funnelflowlist", element: <FunnelFlowList /> },
  { path: "/admin/funnelflowedit", element: <FunnelFlowEdit /> },
  { path: "/admin/bonus-category", element: <BonusCategory /> },
  { path: "/admin/bonus", element: <Bonus /> },
  { path: "/admin/sapphire-add-on", element: <SapphireAddOn /> },
  { path: "/admin/domain-logs", element: <DomainLogs /> },
  { path: "/admin/add-on-queries", element: <UserComments /> },
  { path: "/admin/faq-category", element: <FaqCategory /> },
  { path: "/admin/faq-sub-category", element: <FaqSubCategory /> },
  { path: "/admin/faq-queries", element: <FaqQueries /> },
  { path: "/admin/survey-question", element: <Survey /> },
  { path: "/admin/survey-feedback", element: <SurveyFeedback /> },
  { path: "/admin/support-logs", element: <SupportLogs /> },
  { path: "/admin/overview", element: <ProspectReport /> },
  {
    path: "/admin/prospect-detail",
    element: <ProspectReportDetails />,
  },
  { path: "/admin/report-by-product", element: <ReportByProduct /> },
];
